import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConfigState } from "../interfaces/config/reducer";

const initialState: ConfigState = {
  buyerType: [],
  heardAboutSources: [],
  landBudget: [],
  purchaseTimeframes: [],
  stages: [],
  landSortOptions: [
    {
      id: "price_asc",
      label: "Price: Low to High",
      value: "price_asc",
      sort_by: "price",
      sort_order: "asc",
    },
    {
      id: "price_desc",
      label: "Price: High to Low",
      value: "price_desc",
      sort_by: "price",
      sort_order: "desc",
    },
  ],
};

/**
 * Redux slice for managing global configuration data.
 */
export const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    /**
     * Action to set configuration data.
     * @param {ConfigState} state - Current config state.
     * @param {PayloadAction<Partial<ConfigState>>} action - The payload containing data to update.
     */
    setConfigData: (
      state: ConfigState,
      action: PayloadAction<Partial<ConfigState>>,
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setConfigData } = configSlice.actions;

export default configSlice.reducer;
